import { makeAutoObservable } from 'mobx';
import { UserSessionData } from '~/types/generalSession';
import getIsLoggedIn from './fn/getIsLoggedIn';
import getUserFullName from './fn/getUserFullName';
import logout from './fn/logout';
import getIsSuperAdmin from './fn/getIsSuperAdmin';
import getIsSlagAdmin from './fn/getIsSlagAdmin';
import getIsStandAdmin from './fn/getIsStandAdmin';
import getUserEmail from './fn/getUserEmail';

export default class UserStore {
    user: UserSessionData | null = null;
    isInitialized: boolean = false;
    isLoggingOut: boolean = false;

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.isInitialized = false;
        this.isLoggingOut = false;
        this.user = null;
    }

    setUser(user: UserSessionData | null) {
        this.user = user;
    }

    setIsInitialized(value: boolean) {
        this.isInitialized = value;
    }

    setIsLoggingOut(value: boolean) {
        this.isLoggingOut = value;
    }

    getIsLoggedIn = getIsLoggedIn;
    getUserFullName = getUserFullName;
    getUserEmail = getUserEmail;
    logout = logout;
    getIsSuperAdmin = getIsSuperAdmin;
    getIsSlagAdmin = getIsSlagAdmin;
    getIsStandAdmin = getIsStandAdmin;
}
